import BaseAPI from './BaseAPI'

export default class EventsAPI extends BaseAPI {
  async ack(eventIds) {
    await this.httpClient.post('/v2/events/ack', {
      data: {
        'events': eventIds
      }
    })
  }

  async closeAllConnections() {
    await this.httpClient.del('/v2/events')
  }
}
